__turbopack_context__.v({
  "card": "RecoveryPassesSection-module__5BMZcq__card",
  "cardBody": "RecoveryPassesSection-module__5BMZcq__cardBody",
  "cardDescription": "RecoveryPassesSection-module__5BMZcq__cardDescription",
  "cardTitle": "RecoveryPassesSection-module__5BMZcq__cardTitle",
  "cards": "RecoveryPassesSection-module__5BMZcq__cards",
  "darkSection": "RecoveryPassesSection-module__5BMZcq__darkSection",
  "headerColumn": "RecoveryPassesSection-module__5BMZcq__headerColumn",
  "layout": "RecoveryPassesSection-module__5BMZcq__layout",
  "learnMoreButton": "RecoveryPassesSection-module__5BMZcq__learnMoreButton",
  "shell": "RecoveryPassesSection-module__5BMZcq__shell",
  "stepNumber": "RecoveryPassesSection-module__5BMZcq__stepNumber",
  "stickyHeader": "RecoveryPassesSection-module__5BMZcq__stickyHeader",
  "subtitle": "RecoveryPassesSection-module__5BMZcq__subtitle",
  "textGroup": "RecoveryPassesSection-module__5BMZcq__textGroup",
  "thumb": "RecoveryPassesSection-module__5BMZcq__thumb",
  "title": "RecoveryPassesSection-module__5BMZcq__title",
  "viewPlansCTA": "RecoveryPassesSection-module__5BMZcq__viewPlansCTA",
});
